import React from 'react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

function DoctorCard({ item }) {
  const lang = Cookies.get('i18next') || 'en';
  const navigate = useNavigate();

  return (
    <figure role="presentation" onClick={() => navigate(`/${lang}/doctor/${item.staff.id}`)} className="doctor__card">
      <img className="doctor__card-image" src={item.staff.image.webp_url} alt={item.staff.full_name[lang] || 'Doctor'} />
      <figcaption className="doctor__card-info">
        <p className="doctor__card-info-name">
          {item.staff.full_name[lang]}
        </p>
        {item.specializations.map((e) => (
          <p key={e.id} className="doctor__card-info-posistion">
            {e.title ? e.title[lang] : ''}
          </p>
        ))}
      </figcaption>
    </figure>
  );
}

export default DoctorCard;
